import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    CheckboxControl,
    RadioControl,
    Spinner,
    __experimentalNumberControl as NumberControl,
    Flex,
    FlexItem,
    FlexBlock,
    FormToggle
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';

const ProductTab = ({ openPopup, setActiveTab  }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [modifiedFields, setModifiedFields] = useState({});
     const [hideshowFields, setHideshowFields] = useState([
        { key: 'title', label: 'Title' },
        { key: 'images', label: 'Images' },
        { key: 'short_desc', label: 'Short Description' },
        { key: 'long_desc', label: 'Long Description' },
        { key: 'read_more', label: 'Read More' },
        { key: 'sku', label: 'SKU' },
        { key: 'price', label: 'Price' },
        { key: 'categories', label: 'Categories' },
        { key: 'tags', label: 'Tags' },
        { key: 'brands', label: 'Brands' },
        { key: 'weight', label: 'Weight' },
        { key: 'dimensions', label: 'Dimensions' },
        { key: 'attributes', label: 'Attributes' },
        { key: 'stock_status', label: 'Stock Status' },
        { key: 'gallery', label: 'Gallery' },
    ]);
    const [disablehideshowFields] = useState(['weight','dimensions','attributes', 'stock_status', 'gallery']); 
    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwcp_wp_ajax.getsettings, gmwcp_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
                const newFields = [
                    ...fetchedData.custom_fields.map((field) => ({
                        key: field.gmwcpkey, // Assuming 'field' has a key property
                        label: field.title, // Assuming 'field' has a label property
                    }))
                ];
                // Update state with new fields
                setHideshowFields((prevFields) => [...prevFields, ...newFields]);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [field]: value,
        }));
    };
    const toggleCheckbox = (fieldName, key) => {
        setData((prevData) => {
            const currentValues = prevData[fieldName] || [];
            const updatedValues = currentValues.includes(key)
                ? currentValues.filter((item) => item !== key) // Remove key if already present
                : [...currentValues, key]; // Add key if not present
            return {
                ...prevData,
                [fieldName]: updatedValues,
            };
        });
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [fieldName]: data[fieldName]?.includes(key)
                ? data[fieldName].filter((item) => item !== key)
                : [...(data[fieldName] || []), key],
        }));
    };

    const saveSettings = () => {
         if (Object.keys(modifiedFields).length === 0) {
            openPopup('No changes to save.');
            return;
        }
        setIsSaving(true);

        saveData(gmwcp_wp_ajax.savedata, gmwcp_wp_ajax.nonce, modifiedFields)
            .then((responseData) => {
                setIsSaving(false);
                if (responseData.success) {
                    openPopup('Settings saved!');
                    setModifiedFields({});
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };
    
    return (
        <PanelBody>
             {loading ? (
                <Spinner />
            ) : (
                <>
                        <table className="GMadminTable">
                            <tr>
                                <th>
                                    <label>Enable Single Product Page</label>
                                </th>
                                <td>
                                    <FormToggle
                                      checked={data.gmwcp_single_enable_product === 'yes'}
                                      onChange={() =>
                                            updateField('gmwcp_single_enable_product', data.gmwcp_single_enable_product === 'yes' ? 'no' : 'yes')
                                        }
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Show/Hide Options</label>
                                </th>
                                <td>
                                {hideshowFields.map(({ key, label }) => (
                                        <div
                                            key={key}
                                            
                                            className={disablehideshowFields.includes(key) ? ' gmwcp_flex' : ''} // Conditionally apply class
                                        >
                                            <div    className={disablehideshowFields.includes(key) ? ' gmwcp_disabled' : ''} >
                                                <CheckboxControl
                                                    label={label}
                                                    checked={data.gmwcp_single_show_hide?.includes(key)} // Check if key exists in array
                                                    onChange={() => toggleCheckbox('gmwcp_single_show_hide', key)} // Pass field name and key dynamically
                                                    disabled={disablehideshowFields.includes(key)} // Disable based on `disablehideshowFields` array
                                                />
                                            </div>
                                            {disablehideshowFields.includes(key) && (
                                                <div>
                                                    <a href="https://www.codesmade.com/store/pdf-catalog-woocommerce-pro/" target="_blank">
                                                        Get Pro Version
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                
                                  
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Image Section Width</label>
                                </th>
                                <td>
                                   <NumberControl
                            
                                    help="Keep Max 50"
                                    onChange={(value) => updateField('gmpcp_single_image_width', value)}
                                    value={data.gmpcp_single_image_width}
                                  />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Display Location</label>
                                </th>
                                <td>
                                    <RadioControl
                                    selected={data.gmwcp_single_display_location}
                                    options={ [
                                        { label: 'Before Shop Loop', value: 'before' },
                                        { label: 'After Shop Loop', value: 'after' },
                                        { label: 'Custom Location', value: 'custom' },
                                    ] }
                                    onChange={(value) => updateField('gmwcp_single_display_location', value)}
                                   
                                />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Text Align</label>
                                </th>
                                <td>
                                   <RadioControl
                                        selected={data.gmwcp_single_text_align}
                                        options={ [
                                            { label: 'Left', value: 'left' },
                                            { label: 'Center', value: 'center' },
                                            { label: 'Right', value: 'right' },
                                        ] }
                                        onChange={(value) => updateField('gmwcp_single_text_align', value)}
                                       
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Download File Name</label>
                                </th>
                                <td>
                                   <TextControl
                            
                                    help="Download Time Pdf File Name"
                                    onChange={(value) => updateField('gmwcp_single_download_file_name', value)}
                                    value={data.gmwcp_single_download_file_name}
                                  />
                                </td>
                            </tr>
                        </table>
                        <h4>Custom Location for you need to use shortcode  <code>[gmwcp_single_product]</code> or <code>[gmwcp_single_product id="product_id"]</code></h4>
                        <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                            {isSaving ? <Spinner /> : 'Save Settings'}
                        </Button>
                      </>
            )}
        </PanelBody>
    );
};

export default ProductTab;
